import { AboutSection } from "../components/AboutSection";
import Achievements from "../components/Achievement";
import HeroCarousel from "../components/HeroCarousel";
import { Publications } from "../components/Publications";
import { PublishedJournal } from "../components/PublishedJournal";
import ServiceSections from "../components/ServiceSections";


export default function HomePage() {
  return (
    <>
      <HeroCarousel />
      <ServiceSections />
      <AboutSection />
      <PublishedJournal />
      <Achievements />
      <Publications />
    </>
  );
}
